<template>
  <div class="TopBar-Box" >
      <div class="TopBar-container" :class="[scorllColor?'scorllTop':'']">
        <div class="left">
            <img :src="getsrc" alt="">       
        </div>
        <div class="right" >
            <ul>
                <li class="li-List ">
                    <router-link to="/HomeView" >首页</router-link>
                </li>
                <li class="li-List">
                    <!-- <router-link to="/szbj" >核心产品</router-link> -->
                    <span :class="[isActive1?'Active':'']">核心产品</span>
                    <ul class="routerList">
                        <li><a  @click.prevent="handclick('/szbj','核心产品')" >数字镖局</a></li>
                        <li><a  @click.prevent="handclick('/sx','核心产品')" >数匣</a></li>
                        <div class="listMask"></div>
                        <li><a  @click.prevent="handclick('/Dataset','核心产品')">数据集超市</a></li>
                    </ul>
                </li>
                <li class="li-List"> 
                        <span :class="[isActive2?'Active':'']">数据服务</span>
                    <ul class="routerList">
                        <li><a   @click.prevent="handclick('/sjfw','数据服务')">数据服务</a></li>
                        <div class="listMask"></div>
                        <li><a   @click.prevent="handclick('/Dataset','数据服务')">数据集超市</a></li>
                    </ul>
                </li>
                <li class="li-List">
                    <router-link to="/gywm">关于我们</router-link>
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets1/logo_slices/编组 2(1).png" 
import router from '@/router'
export default {
// linkActiveClass: 'active',
// linkExactActiveClass: 'active',
data(){
    return {
    logo,
        isActive1:false,
        isActive2:false,
        router1:['/szbj','/sx'],
        router2:['/sjfw'],
        getcolor:this.color,
        getsrc:this.src
    }
},
    props:{
        title:{
            type:String,
            required:true
        },
        color:{
            default:'#fff'
        },
        src:{
            required:true
        },
        
        // list:{
        //     type:Array,
        //     required:true
        // }
    },

   watch:{
    $route(newValue){
     this.getRouter()
    }
   }
    ,methods:{
        handclick(it,title){
         if(title==='核心产品'){
                this.isActive1=true
                this.isActive2=false
            }else{
                this.isActive1=false
                this.isActive2=true
            }
            
            
            if(this.$route.path===it){
                return
            }
           
            router.push(it)
        },
        getRouter(){
            const hxcp=this.router1.includes(this.$route.path)
            const sjfw=this.router2.includes(this.$route.path)
            this.isActive1=hxcp?true:false
            this.isActive2=sjfw?true:false
            
        }
        
    },
    created(){
        this.getRouter()
   
        
    },
    computed:{
        scorllColor(){
           
           
            
            if(this.$store.state.scorllTop>300){
               this.getcolor='#000'
                this.getsrc=logo
                return true
            }else{

             this.getcolor=this.color
                this.getsrc=this.src
                return false
            }
           
        },
        setfixed(){
            if(this.scorllColor){
                return `fixed`
            }else{
                return 'absolute'
            }
        },
        Height(){
            if(this.$store.state.scorllTop>300){
                return '40px'
            }
            return '45px'
        }
    }
    
}
</script>

<style scoped>
.scorllTop{
    background-color: #fff;
  border-bottom: 1px solid #ccc;
}
.li-List:hover .routerList{
   transform: translateX(-50%) scaleY(1);
 
}
.listMask{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
    border-radius: 8px 8px 8px 8px;
    z-index: -1;
}
.TopBar-Box{
   min-width: 100%;
   position: relative;
}
.routerList{
    position: absolute;
    display: flex;
    flex-direction: column;
    font-family:Regular ;
    font-weight: 400;
    font-size: 10px;
    color: #222222;
    line-height: 20px;
    top: 48px;
    left: 50%;
    transform: translateX(-50%) scaleY(0);
    text-align: center;
      width: 120px;

    transform-origin: center top;
    transition: 200ms;
}
.right .routerList>li{
    width: 100%;
    display: block;
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    
}
.right .routerList>li:nth-child(1){
   border-radius: 8px 8px 0 0;
   
}
.right .routerList>li:last-child{
   border-radius:  0 0 8px 8px;
}
.right .routerList>li:hover{
  
  background: rgba(13,83,255,0.12);
 
   
}
.li-List a.router-link-active{
        font-family: Bold;
       color: v-bind(getcolor);
}
.Active{
        font-family: Bold;
      color: v-bind(getcolor);
}
.TopBar-container{
    /* width: 70%; */
      min-width: 100%;
    position: v-bind(setfixed);
    height: 80px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    padding: 15px 10px;
    color: white;
    z-index: 10;
    top: 0;
   padding-left: 360px;
}
.active{
    color: #fff;
}   
.li-List{
    font-family: Regular;
    color: #6b7ea0;
    position: relative;
    cursor: pointer;
}  
.right ul{
    display: flex;
    justify-content: space-between;
}
.right ul li{

height: 22px;
/* font-family: PingFangSC, PingFang SC; */
margin-right: 50px;
font-weight: 500;
font-size: 18px;

line-height: 45px;

font-style: normal;
 
}
.right ul li:last-child{
   margin-right: 0px;

 
}

.left{
    display: flex;
    align-content: center;
}
.left img{
    width: 293px;
    /* height: v-bind(Height); */
    height: 45px;
    margin-right: 533px;
}


</style>